export default {
  title: 'Wie möchtest du bestellen?',
  options: {
    dine_in: 'Am Tisch',
    takeaway: 'Abholung / Lieferung',
  },
};
